import Player from './player';
import Const from 'const';
import Action from 'actions';

export default class PlayerTiers extends Player {
    getExpandedEntityParams({incomingValues = {}}) {
        const expandedPlayer = super.getExpandedEntityParams({
            incomingValues,
        });

        return {
            ...expandedPlayer,
            salary: 0,
            isExcludedBySalary(mode) {
                return false;
            },
            isFitForLineup: function (substitutablePlayer) {
                return substitutablePlayer.rosterPositionName === this.rosterPositionName;
            },
            isConfirmed: function () {
                return expandedPlayer.confirmed === Const.MLB_PLAYER_CONFIRMED;
            },
        };
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('rangeOfOutcomesByPositions')) {
            dispatch(Action.setRangeOfOutcomesByPositionsFromStorage(data.rangeOfOutcomesByPositions));
        }

        if (data.hasOwnProperty('playerConfirmed')) {
            dispatch(Action.set('PlayerConfirmedFilterFromStorage', data.playerConfirmed));
        }

        if (data.hasOwnProperty('hittersOrder')) {
            dispatch(Action.set('HittersOrderFromStorage', data.hittersOrder));
        }
    }
}
